/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrMedicationReconciliationFormTypename = "PhrMedicationReconciliationForm" as const;

/**
 *
 * @export
 * @interface PhrMedicationReconciliationForm
 */
export interface PhrMedicationReconciliationForm {
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  alcohol?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  alcoholAmount?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  anemia?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  beforeBedtimeEating?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  desireForHealthGuidance?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  exerciseHabits?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  fastEating?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  firstInterviewImplementation?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  foodHabits?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  improvementOfLifestyleHabits?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  mastication?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  medicalHistoryCardiovascular?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  medicalHistoryCerebralVascular?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  medicalHistoryKidneyFailure?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  providingInformationMethod?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  sleep?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  smoking?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  snacksEating?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  takingBloodPressureMedicine?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  takingDiabetesMedicine?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  takingDyslipidemiaMedicine?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  walking?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  walkingSpeed?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  weightChange?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrMedicationReconciliationForm
   */
  readonly __typename?: string;
}

export function PhrMedicationReconciliationFormFromJSON(json: any): PhrMedicationReconciliationForm {
  return PhrMedicationReconciliationFormFromJSONTyped(json, false);
}

export function PhrMedicationReconciliationFormFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PhrMedicationReconciliationForm {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrMedicationReconciliationFormTypename,

    alcohol: !exists(json, "alcohol") ? undefined : json["alcohol"],
    alcoholAmount: !exists(json, "alcohol_amount") ? undefined : json["alcohol_amount"],
    anemia: !exists(json, "anemia") ? undefined : json["anemia"],
    beforeBedtimeEating: !exists(json, "before_bedtime_eating") ? undefined : json["before_bedtime_eating"],
    desireForHealthGuidance: !exists(json, "desire_for_health_guidance")
      ? undefined
      : json["desire_for_health_guidance"],
    exerciseHabits: !exists(json, "exercise_habits") ? undefined : json["exercise_habits"],
    fastEating: !exists(json, "fast_eating") ? undefined : json["fast_eating"],
    firstInterviewImplementation: !exists(json, "first_interview_implementation")
      ? undefined
      : json["first_interview_implementation"],
    foodHabits: !exists(json, "food_habits") ? undefined : json["food_habits"],
    improvementOfLifestyleHabits: !exists(json, "improvement_of_lifestyle_habits")
      ? undefined
      : json["improvement_of_lifestyle_habits"],
    mastication: !exists(json, "mastication") ? undefined : json["mastication"],
    medicalHistoryCardiovascular: !exists(json, "medical_history_cardiovascular")
      ? undefined
      : json["medical_history_cardiovascular"],
    medicalHistoryCerebralVascular: !exists(json, "medical_history_cerebral_vascular")
      ? undefined
      : json["medical_history_cerebral_vascular"],
    medicalHistoryKidneyFailure: !exists(json, "medical_history_kidney_failure")
      ? undefined
      : json["medical_history_kidney_failure"],
    providingInformationMethod: !exists(json, "providing_information_method")
      ? undefined
      : json["providing_information_method"],
    sleep: !exists(json, "sleep") ? undefined : json["sleep"],
    smoking: !exists(json, "smoking") ? undefined : json["smoking"],
    snacksEating: !exists(json, "snacks_eating") ? undefined : json["snacks_eating"],
    takingBloodPressureMedicine: !exists(json, "taking_blood_pressure_medicine")
      ? undefined
      : json["taking_blood_pressure_medicine"],
    takingDiabetesMedicine: !exists(json, "taking_diabetes_medicine") ? undefined : json["taking_diabetes_medicine"],
    takingDyslipidemiaMedicine: !exists(json, "taking_dyslipidemia_medicine")
      ? undefined
      : json["taking_dyslipidemia_medicine"],
    walking: !exists(json, "walking") ? undefined : json["walking"],
    walkingSpeed: !exists(json, "walking_speed") ? undefined : json["walking_speed"],
    weightChange: !exists(json, "weight_change") ? undefined : json["weight_change"],
  };
}

export function PhrMedicationReconciliationFormToJSON(object?: PhrMedicationReconciliationForm | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    alcohol: value.alcohol,
    alcohol_amount: value.alcoholAmount,
    anemia: value.anemia,
    before_bedtime_eating: value.beforeBedtimeEating,
    desire_for_health_guidance: value.desireForHealthGuidance,
    exercise_habits: value.exerciseHabits,
    fast_eating: value.fastEating,
    first_interview_implementation: value.firstInterviewImplementation,
    food_habits: value.foodHabits,
    improvement_of_lifestyle_habits: value.improvementOfLifestyleHabits,
    mastication: value.mastication,
    medical_history_cardiovascular: value.medicalHistoryCardiovascular,
    medical_history_cerebral_vascular: value.medicalHistoryCerebralVascular,
    medical_history_kidney_failure: value.medicalHistoryKidneyFailure,
    providing_information_method: value.providingInformationMethod,
    sleep: value.sleep,
    smoking: value.smoking,
    snacks_eating: value.snacksEating,
    taking_blood_pressure_medicine: value.takingBloodPressureMedicine,
    taking_diabetes_medicine: value.takingDiabetesMedicine,
    taking_dyslipidemia_medicine: value.takingDyslipidemiaMedicine,
    walking: value.walking,
    walking_speed: value.walkingSpeed,
    weight_change: value.weightChange,
  };
}
